<template>
  <b-form @submit.prevent="submit">
    <b-row>
      <b-col md="2">
        <b-form-group label="Estatus">
          <b-form-select v-model="form.status" :options="statusOptions" />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group label="Confirmación">
          <b-form-input v-model="form.folio" type="text" placeholder="Código" />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group label="Vivienda">
          <b-form-input v-model="form.housing" type="text" inputmode="numeric" :state="housingState" placeholder="Número" />
          <b-form-invalid-feedback>Ingrese un número de vivienda válido</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group label="Propietario">
          <b-form-input v-model="form.owner" type="text" placeholder="Nombre" />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group label="Visita desde">
          <b-form-input v-model="form.startDate" type="date" />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group label="Visita hasta">
          <b-form-input v-model="form.endDate" type="date" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8">
        <small v-if="rangeIncomplete" class="text-danger">Visita requiere ambas fechas</small>
      </b-col>
      <b-col md="4" class="text-right">
        <b-button variant="warning" class="mr-1" :disabled="isLoading" @click="clear">Limpiar</b-button>
        <b-button variant="primary" type="submit" :disabled="isLoading || !isValid">Buscar</b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { xcalacocoBookingStatusOptions } from '@/data/xcalacocoBookings'

const MAX_INT = 2147483647

function initialForm() {
  return {
    status: '1',
    folio: '',
    housing: '',
    owner: '',
    startDate: '',
    endDate: '',
  }
}

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    initialFilters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const form = { ...initialForm(), ...this.initialFilters }
    form.housing = form.housing ? String(form.housing) : ''
    return {
      form,
      statusOptions: xcalacocoBookingStatusOptions,
    }
  },
  computed: {
    housingState() {
      const value = this.form.housing.trim()
      if (!value) return null
      return /^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= MAX_INT ? null : false
    },
    rangeIncomplete() {
      return !this.form.startDate !== !this.form.endDate
    },
    isValid() {
      return this.housingState !== false && !this.rangeIncomplete
    },
  },
  methods: {
    buildParams() {
      const { form } = this
      const params = { status: form.status }
      const folio = form.folio.trim()
      if (folio) params.folio = folio
      const housing = form.housing.trim()
      if (housing) params.housing = parseInt(housing, 10)
      const owner = form.owner.trim()
      if (owner) params.owner = owner
      if (form.startDate && form.endDate) {
        params.startDate = form.startDate
        params.endDate = form.endDate
      }
      return params
    },
    submit() {
      if (!this.isValid || this.isLoading) return
      this.$emit('search', this.buildParams())
    },
    clear() {
      this.form = initialForm()
      this.$emit('search', this.buildParams())
    },
  },
}
</script>
